var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null-page",style:({ marginTop: _vm.height + 'px' })},[_c('div',{staticClass:"createActive"},[_c('img',{staticClass:"no-create",attrs:{"src":require("../images/nullData.png"),"alt":""}}),_c('p',{staticClass:"null-info",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"btn-list"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }